export default __webpack_public_path__ + "static/media/tms-portabella-8000i.51c4f3fc.webp";